<template>
  <div class="jackpot__manufacturers" :class="{ 'jackpot__manufacturers--one-element': manufacturers.length === 1 }">
    <swiper v-bind="swiperOptions" :modules="[Grid, FreeMode]" class="swiper-jackpot" @swiper="onSwiper">
      <swiper-slide v-for="(manufacturer, key) in manufacturers" :key="key">
        <div
          class="jackpot__manufacturers-item"
          :class="{ 'jackpot__manufacturers-item--active': active === key }"
          @click="emit('change', key)"
        >
          <jackpot-manufacturer-logo :manufacturer="manufacturer" />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { FreeMode, Grid } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import { ref } from 'vue'
import JackpotManufacturerLogo from 'components/jackpot/JackpotManufacturerLogo.vue'
defineProps({
  manufacturers: {
    type: Array,
    default: () => [],
  },
  active: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['change'])

const swiperOptions = {
  slidesPerView: 'auto',
  slidesPerGroup: 3,
  threshold: 10,
  spaceBetween: 6,
}

const swiperInstance = ref(null)

function onSwiper(swiper) {
  swiperInstance.value = swiper
}
</script>

<style lang="scss" scoped>
.swiper-jackpot {
  @include mobile {
    overflow: visible;
  }

  .swiper-slide {
    width: 106px !important;
  }
}

.jackpot__manufacturers {
  margin-top: 24px;

  &--one-element {
    display: flex;
    justify-content: center;
  }

  @include tab {
    margin-top: 10px;
  }
  @include desktop {
    margin-top: 0;
  }

  &-item {
    height: 48px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.07);
    backdrop-filter: blur(4px);
    padding: 4px;
    cursor: pointer;
    transition: 0.24s;
    border: 1px solid rgba(0, 0, 0, 0);

    &:hover {
      border: 1px solid var(--Primary-Color-Yellow-700, #f6a913);
    }

    &--active {
      border: 1px solid var(--Primary-Color-Yellow-700, #f6a913);
    }
  }
}
</style>
